module.exports = {"440205001":"松山街道","440205100":"马坝镇","440205101":"大塘镇","440205102":"枫湾镇","440205103":"小坑镇","440205104":"沙溪镇","440205106":"乌石镇","440205107":"樟市镇","440205108":"白土镇","440205109":"罗坑镇","440205451":"韶关发电厂","440205452":"曲江区大宝山矿","440205453":"韶关十六冶金建设公司"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440205.json
// module id = 1787
// module chunks = 0